
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import PendoIcon from './pendo-icon.js';
import { i as isValidHex, b as getContrastingColor, a as getAlpha, D as DEFAULT_PRESETS } from './color-picker-helper-mixin.js';
import isNumber from 'lodash/isNumber';

var script = {
  name: 'ColorPickerCheckboard',
  props: {
    size: {
      type: Number,
      default: 10
    }
  },
  computed: {
    bgStyle() {
      return {
        backgroundColor: '#c5c5c5',
        backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'100\' height=\'100\' fill=\'%23fff\'%3E%3Crect x=\'50\' width=\'50\' height=\'50\' /%3E%3Crect y=\'50\' width=\'50\' height=\'50\' /%3E%3C/svg%3E")',
        backgroundSize: `${this.size}px ${this.size}px`
      };
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "color-picker-checkboard",
    style: _vm.bgStyle
  });
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "color-picker-checkboard.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var ColorPickerCheckboard = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'ColorPickerSwatch',
  components: {
    PendoIcon,
    ColorPickerCheckboard
  },
  props: {
    value: {
      type: String,
      default: null,
      validator: value => isValidHex(value)
    },
    color: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: 16
    }
  },
  computed: {
    styleObj() {
      if (isNumber(this.size)) {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`
        };
      }

      return {
        width: this.size,
        height: this.size
      };
    },

    selectedIconProps() {
      return {
        type: 'check',
        strokeWidth: 2.5,
        stroke: getContrastingColor(this.value),
        size: this.size * 0.6
      };
    },

    isTransparent() {
      return getAlpha(this.color) !== 1;
    },

    isSelected() {
      if (this.value) {
        return this.color.toLowerCase() === this.value.toLowerCase();
      }

      return false;
    }

  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._g({
    staticClass: "pendo-color-picker-swatch",
    class: {
      'is-selected': _vm.isSelected
    },
    style: _vm.styleObj,
    attrs: {
      "role": "option",
      "aria-label": 'color:' + _vm.color,
      "aria-selected": _vm.isSelected
    }
  }, _vm.$listeners), [_vm.isSelected ? _c('pendo-icon', _vm._b({
    staticClass: "pendo-color-picker-swatch__selected-icon"
  }, 'pendo-icon', _vm.selectedIconProps, false)) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-color-picker-swatch__color",
    style: {
      backgroundColor: _vm.color
    }
  }), _vm._v(" "), _vm.isTransparent ? _c('color-picker-checkboard', {
    staticClass: "pendo-color-picker-swatch__checkboard",
    attrs: {
      "size": _vm.size / 2
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "color-picker-swatch.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var ColorPickerSwatch = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

var script$2 = {
  name: 'PendoColorPickerPresets',
  components: {
    ColorPickerSwatch
  },
  props: {
    value: {
      type: String,
      default: null,
      validator: value => isValidHex(value)
    },
    presets: {
      type: Array,
      default: () => DEFAULT_PRESETS
    },
    size: {
      type: Number,
      default: 16
    }
  },
  methods: {
    onPresetSelect(color) {
      this.$emit('change', color);
    }

  }
};

const __vue_script__$2 = script$2;

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-color-picker-presets",
    style: {
      gridTemplateColumns: "repeat(auto-fill, " + _vm.size + "px)"
    }
  }, _vm._l(_vm.presets, function (color) {
    return _c('color-picker-swatch', {
      key: color,
      attrs: {
        "tabindex": "0",
        "color": color,
        "value": _vm.value,
        "size": _vm.size
      },
      on: {
        "click": function ($event) {
          return _vm.onPresetSelect(color);
        },
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          return _vm.onPresetSelect(color);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$2 = [];
const __vue_inject_styles__$2 = undefined;
const __vue_scope_id__$2 = undefined;
const __vue_is_functional_template__$2 = false;

function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-color-picker-presets.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var ColorPickerPresets = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2);

export { ColorPickerCheckboard as C, ColorPickerSwatch as a, ColorPickerPresets as b };
